/**
 * Marathi (मराठी) translations
 */
import { TranslationStrings } from '../types';

export const mr: TranslationStrings = {  common: {
    loading: 'लोड होत आहे...',
    error: 'एक त्रुटी आली',
    retry: 'पुन्हा प्रयत्न करा',
    cancel: 'रद्द करा',
    confirm: 'पुष्टी करा',
    back: 'मागे',
    next: 'पुढे',
    submit: 'सादर करा',
    done: 'झाले',
    close: 'बंद करा',
    yes: 'होय',
    no: 'नाही',
    required: 'आवश्यक',
    optional: 'ऐच्छिक',
  },
  consent: {
    secureConsent: 'सुरक्षित संमती',
    yourConsentRequired: 'तुमची संमती आवश्यक आहे',
    consentingAs: 'म्हणून संमती देत आहे',
    requestingOrg: 'विनंती करणारी संस्था',
    dataBeingCollected: 'गोळा केला जाणारा डेटा',
    purposeOfProcessing: 'प्रक्रियेचा उद्देश',
    whatYouWillDo: 'तुम्ही काय कराल',
    reviewDocuments: 'कागदपत्रांचे पुनरावलोकन करा',
    provideConsent: 'संमती द्या',
    documentsToRead: 'वाचण्यासाठी कागदपत्रे',
    estimatedTime: 'अंदाजे वेळ',
    minutes: 'मिनिटे',
    startReview: 'पुनरावलोकन सुरू करा',
    yourRights: 'DPDP कायदा 2023 अंतर्गत तुमचे अधिकार',
    rightToAccess: 'तुमचा डेटा ऍक्सेस करण्याचा अधिकार',
    rightToCorrect: 'तुमचा डेटा दुरुस्त करण्याचा अधिकार',
    rightToWithdraw: 'संमती मागे घेण्याचा अधिकार',
    rightToGrievance: 'तक्रार दाखल करण्याचा अधिकार',
    stepOf: 'चरण {current} / {total}',
    pleaseReadCarefully: 'कृपया संमती देण्यापूर्वी प्रत्येक कागदपत्र काळजीपूर्वक वाचा.',
    documentsReviewed: 'पुनरावलोकन केलेली कागदपत्रे',
    remaining: 'उर्वरित',
    allDocumentsReviewed: 'सर्व कागदपत्रांचे पुनरावलोकन झाले!',
    clickToRead: 'वाचण्यासाठी प्रत्येक कागदपत्रावर क्लिक करा',
    proceedToConsent: 'तुम्ही संमती देण्यासाठी पुढे जाऊ शकता',
    markAsRead: 'वाचल्याचे चिन्हांकित करा',
    continueReading: 'वाचन सुरू ठेवा',
    confirmConsent: 'तुमची संमती पुष्टी करा',
    selectMethod: 'पडताळणी पद्धत निवडा',
    iAgreeToTerms: 'मी सर्व अटी, धोरणे आणि संमती करारांशी सहमत आहे',
    readAllDocuments: 'माझी संमती स्वैच्छिक आहे आणि कधीही मागे घेता येते हे मला समजते',
    submitConsent: 'संमती सादर करा',
    submitting: 'सादर होत आहे...',
    digitalSignature: 'डिजिटल स्वाक्षरी',
    smsVerification: 'SMS पडताळणी',
    emailVerification: 'ईमेल पडताळणी',
    videoRecording: 'व्हिडिओ रेकॉर्डिंग',
    audioRecording: 'ऑडिओ रेकॉर्डिंग',
    checkboxConfirmation: 'चेकबॉक्स पुष्टी',
    drawSignature: 'तुमची स्वाक्षरी काढा',
    verifyViaSms: 'SMS कोडद्वारे पडताळणी करा',
    verifyViaEmail: 'ईमेल कोडद्वारे पडताळणी करा',
    recordVideoConsent: 'व्हिडिओ संमती रेकॉर्ड करा',
    recordAudioConsent: 'ऑडिओ संमती रेकॉर्ड करा',
    confirmByChecking: 'चेक करून पुष्टी करा',
    enterOtp: 'OTP प्रविष्ट करा',
    otpSentTo: 'OTP पाठवला',
    resendOtp: 'OTP पुन्हा पाठवा',
    verifyOtp: 'OTP पडताळा',
    otpVerified: 'OTP पडताळला',
    invalidOtp: 'अवैध OTP',
    startRecording: 'रेकॉर्डिंग सुरू करा',
    stopRecording: 'रेकॉर्डिंग थांबवा',
    retake: 'पुन्हा घ्या',
    recordingComplete: 'रेकॉर्डिंग पूर्ण',
    consentSubmitted: 'संमती यशस्वीरित्या सादर केली',
    thankYou: 'तुमची संमती दिल्याबद्दल धन्यवाद',
    confirmationSent: 'तुमच्या ईमेलवर पुष्टी पाठवली आहे',
    referenceNumber: 'संदर्भ क्रमांक',
    errorSubmitting: 'संमती सादर करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
    pleaseReadDocs: 'कृपया आधी सर्व कागदपत्रे वाचा',
    pleaseProvideEvidence: 'कृपया संमती पुरावा द्या',
  },
  documents: {
    privacyPolicy: 'गोपनीयता धोरण',
    termsOfService: 'सेवा अटी',
    consentAgreement: 'संमती',
    dataSharingAgreement: 'डेटा शेअरिंग करार',
    cookiePolicy: 'कुकी धोरण',
    retentionPolicy: 'डेटा धारण धोरण',
    gdprNotice: 'GDPR सूचना',
    hipaaAuthorization: 'HIPAA अधिकृतता',
    ccpaDisclosure: 'CCPA प्रकटीकरण',
    aadhaarAuthorization: 'आधार अधिकृतता',
    customDocument: 'सानुकूल कागदपत्र',
  },
  dataCategories: {
    personalInfo: 'वैयक्तिक माहिती',
    contactDetails: 'संपर्क तपशील',
    financialInfo: 'आर्थिक माहिती',
    healthData: 'आरोग्य आणि वैद्यकीय डेटा',
    biometricData: 'बायोमेट्रिक डेटा',
    locationData: 'स्थान डेटा',
    behavioralData: 'वर्तणूक डेटा',
    communicationData: 'संवाद डेटा',
    employmentInfo: 'रोजगार माहिती',
    educationInfo: 'शैक्षणिक माहिती',
  },
  a11y: {
    mainContent: 'मुख्य सामग्री',
    navigation: 'नेव्हिगेशन',
    closeModal: 'मोडल बंद करा',
    expandSection: 'विभाग विस्तृत करा',
    collapseSection: 'विभाग संकुचित करा',
    documentRead: 'कागदपत्र वाचल्याचे चिन्हांकित',
    documentUnread: 'कागदपत्र अजून वाचले नाही',
    progressIndicator: 'प्रगती: {current} / {total} कागदपत्रे वाचली',
    signaturePad: 'स्वाक्षरी क्षेत्र',
    clearSignature: 'स्वाक्षरी साफ करा',
    videoPlayer: 'व्हिडिओ रेकॉर्डिंग प्लेयर',
    audioPlayer: 'ऑडिओ रेकॉर्डिंग प्लेयर',
    requiredField: 'हे फील्ड आवश्यक आहे',
    errorMessage: 'त्रुटी',
    successMessage: 'यश',
    loadingContent: 'सामग्री लोड होत आहे, कृपया प्रतीक्षा करा',
    newWindow: 'नवीन विंडोमध्ये उघडते',
  },
  portal: {
    // General
    myConsents: 'माझ्या संमती',
    viewManageConsents: 'तुमचे संमती रेकॉर्ड पहा आणि व्यवस्थापित करा',
    logout: 'लॉगआउट',
    welcomeBack: 'पुन्हा स्वागत',
    
    // Tenant selector
    organizationNameOrCode: 'संस्थेचे नाव किंवा कोड',
    orgPlaceholder: 'उदा., globalhealth किंवा acme-corp',
    orgHint: 'तुमच्या संस्थेने दिलेले नाव किंवा कोड प्रविष्ट करा',
    findMyOrganization: 'माझी संस्था शोधा',
    orgNotFound: 'संस्था सापडली नाही. कृपया नाव तपासून पुन्हा प्रयत्न करा.',
    enterOrgName: 'कृपया तुमच्या संस्थेचे नाव किंवा कोड प्रविष्ट करा',
    or: 'किंवा',
    haveDirectLink: 'तुमच्या संस्थेकडून थेट लिंक आहे का?',
    useDirectLink: 'त्यांनी दिलेली लिंक वापरा',
    privacyProtected: 'तुमची गोपनीयता कायद्याने संरक्षित आहे',
    
    // Login flow
    phoneOrEmail: 'फोन नंबर किंवा ईमेल',
    enterPhoneOrEmailPlaceholder: 'तुमचा नोंदणीकृत फोन किंवा ईमेल प्रविष्ट करा',
    otpWillBeSent: 'आम्ही तुम्हाला वन-टाइम पासवर्ड (OTP) पाठवू',
    sendOtp: 'OTP पाठवा',
    enterPhoneOrEmail: 'कृपया तुमचा फोन नंबर किंवा ईमेल प्रविष्ट करा',
    otpSentTo: 'OTP पाठवला',
    expiresIn: 'कालबाह्य होईल',
    enterOtp: 'OTP प्रविष्ट करा',
    enterValidOtp: 'कृपया वैध OTP प्रविष्ट करा',
    verifyOtp: 'OTP पडताळा',
    resendOtp: 'OTP पुन्हा पाठवा',
    otpVerified: 'OTP पडताळला',
    oneMoreStep: 'तुमची ओळख पडताळण्यासाठी आणखी एक पाऊल',
    enterSecurityAnswer: 'कृपया तुमचे उत्तर प्रविष्ट करा',
    enterAnswer: 'उत्तर प्रविष्ट करा',
    dobFormat: 'स्वरूप: DDMMYYYY (उदा., 15051990 मे 15, 1990)',
    login: 'लॉगिन',
    startOver: 'पुन्हा सुरू करा',
    needHelp: 'मदत हवी?',
    privacyNotice: 'तुमचा डेटा लागू गोपनीयता कायद्यांतर्गत संरक्षित आहे',
    checkUrlOrContact: 'कृपया URL तपासा किंवा तुमच्या संस्थेशी संपर्क साधा.',
    
    // Consent history
    filterAll: 'सर्व',
    statusActive: 'सक्रिय',
    statusWithdrawn: 'मागे घेतले',
    statusExpired: 'कालबाह्य',
    noConsents: 'संमती रेकॉर्ड सापडले नाहीत',
    noConsentsWithFilter: 'या स्थितीत संमती नाहीत',
    consentedOn: 'संमती दिली',
    expiresOn: 'कालबाह्य होईल',
    withdrawnOn: 'मागे घेतले',
    withdrawConsent: 'संमती मागे घ्या',
    withdrawalHistory: 'मागे घेण्याचा इतिहास',
    help: 'मदत',
    
    // Withdrawal
    cannotWithdraw: 'ही संमती मागे घेता येत नाही',
    pleaseConfirmWithdrawal: 'कृपया परिणाम समजल्याची पुष्टी करा',
    importantNotice: 'महत्त्वाची सूचना',
    withdrawalNotice1: 'संस्था नमूद केलेल्या उद्देशांसाठी तुमचा डेटा प्रक्रिया करणे थांबवेल.',
    withdrawalNotice2: 'कायदेशीर अनुपालनासाठी काही डेटा ठेवला जाऊ शकतो.',
    withdrawalNotice3: 'काही सेवा वापरण्यासाठी तुम्हाला पुन्हा संमती देणे आवश्यक असू शकते.',
    withdrawalNotice4: 'लागू कायद्यांनुसार प्रक्रिया वेळ 7-30 दिवस लागू शकतो.',
    withdrawalReason: 'मागे घेण्याचे कारण',
    withdrawalReasonPlaceholder: 'तुम्ही का मागे घ्यायचे आहे ते सांगा (वैकल्पिक)',
    withdrawalConfirmation: 'माझी संमती मागे घेतल्याने काही सेवा वापरण्याच्या माझ्या क्षमतेवर परिणाम होऊ शकतो हे मला समजले आहे, आणि मला या विनंतीसह पुढे जायचे आहे.',
    submitWithdrawalRequest: 'मागे घेण्याची विनंती सबमिट करा',
    withdrawalSubmitted: 'मागे घेण्याची विनंती सबमिट झाली',
    withdrawalSubmittedDesc: 'तुमची मागे घेण्याची विनंती सबमिट झाली आहे. संस्था प्रक्रिया केल्यावर तुम्हाला सूचित केले जाईल.',
    processingTime: 'प्रक्रिया वेळ',
    days: 'दिवस',
    backToHistory: 'संमती इतिहासाकडे परत जा',
    
    // Withdrawal history
    statusPending: 'प्रलंबित',
    statusApproved: 'मंजूर',
    statusRejected: 'नाकारले',
    noWithdrawals: 'मागे घेण्याच्या विनंत्या नाहीत',
    viewConsents: 'तुमच्या संमती पहा',
    requestedOn: 'विनंती केली',
    processedOn: 'प्रक्रिया केली',
    processingMessage: 'तुमच्या विनंतीवर प्रक्रिया होत आहे. पूर्ण झाल्यावर तुम्हाला सूचित केले जाईल.',
    processingTimeInfo: 'प्रक्रिया वेळ माहिती',
    
    // Help section
    yourRights: 'तुमचे गोपनीयता हक्क',
    helpTitle: 'तुमचे गोपनीयता हक्क समजून घ्या',
    helpSubtitle: 'गोपनीयता कायद्यांतर्गत तुमचे हक्क आणि संमती कशी व्यवस्थापित करायची ते जाणून घ्या.',
    quickActions: 'जलद कृती',
    viewMyConsents: 'माझ्या संमती पहा',
    viewWithdrawalRequests: 'मागे घेण्याच्या विनंत्या पहा',
    loginToViewConsents: 'तुमच्या संमती पाहण्यासाठी लॉगिन करा',
    applicableLaws: 'लागू गोपनीयता कायदे',
    
    // Rights FAQ
    rightAccessQ: 'प्रवेश हक्क म्हणजे काय?',
    rightAccessA: 'तुमच्याबद्दल कोणता वैयक्तिक डेटा गोळा केला जात आहे, तो कसा वापरला जात आहे, कोणासोबत शेअर केला जात आहे हे जाणून घेण्याचा तुम्हाला हक्क आहे.',
    rightCorrectQ: 'दुरुस्तीचा हक्क म्हणजे काय?',
    rightCorrectA: 'तुमचा वैयक्तिक डेटा चुकीचा किंवा अपूर्ण असल्यास, तो दुरुस्त किंवा अपडेट करण्याची विनंती करू शकता.',
    rightWithdrawQ: 'संमती मागे घेण्याचा हक्क म्हणजे काय?',
    rightWithdrawA: 'तुम्ही कधीही तुमची संमती मागे घेऊ शकता. मागे घेतल्यानंतर, तुम्ही संमती दिलेल्या उद्देशांसाठी तुमचा डेटा प्रक्रिया करणे संस्थेने थांबवणे आवश्यक आहे.',
    rightEraseQ: 'पुसून टाकण्याचा हक्क म्हणजे काय?',
    rightEraseA: '"विसरून जाण्याचा हक्क" म्हणूनही ओळखला जाणारा, तुमचा वैयक्तिक डेटा हटवण्याची विनंती करू शकता. तथापि, काही माहिती ठेवण्यासाठी कायदेशीर कारणे असू शकतात.',
    
    // Withdrawal FAQ
    withdrawalFaq: 'मागे घेण्याची प्रक्रिया',
    withdrawHowQ: 'माझी संमती कशी मागे घ्यायची?',
    withdrawHowA: 'तुमच्या खात्यात लॉगिन करा, संमती इतिहासावर जा, सक्रिय संमतीवर "संमती मागे घ्या" क्लिक करा.',
    withdrawTimeQ: 'मागे घेण्यास किती वेळ लागतो?',
    withdrawTimeA: 'लागू कायद्यांनुसार प्रक्रिया वेळ: DPDP कायदा (भारत) - 7 दिवस, GDPR (EU) - 30 दिवस, CCPA (कॅलिफोर्निया) - 45 दिवस.',
    withdrawEffectQ: 'संमती मागे घेतल्यानंतर काय होते?',
    withdrawEffectA: 'नमूद केलेल्या उद्देशांसाठी तुमचा डेटा वापरणे संस्था थांबवेल. कायदेशीर अनुपालनासाठी काही डेटा ठेवला जाऊ शकतो.',
    
    // Security FAQ
    securityFaq: 'खाते सुरक्षा',
    loginSecureQ: 'माझे लॉगिन कसे सुरक्षित आहे?',
    loginSecureA: 'आम्ही 3-चरण पडताळणी प्रक्रिया वापरतो: नोंदणीकृत फोन/ईमेलवर OTP, त्यानंतर सुरक्षा प्रश्न.',
    dataProtectQ: 'माझा डेटा कसा संरक्षित आहे?',
    dataProtectA: 'सर्व डेटा ट्रांझिट आणि विश्रांतीमध्ये एन्क्रिप्ट केला जातो. DPDP कायदा, GDPR आणि इतर गोपनीयता नियमांचे पालन करतो.',
    
    // Contact FAQ
    contactFaq: 'संपर्क आणि समर्थन',
    grievanceQ: 'तक्रार कशी दाखल करायची?',
    grievanceA: 'संस्थेच्या डेटा संरक्षण अधिकारी (DPO) किंवा तक्रार अधिकाऱ्याशी संपर्क साधू शकता.',
    regulatorQ: 'नियामक प्राधिकरण कोण आहे?',
    regulatorA: 'भारतात, डेटा संरक्षण मंडळ गोपनीयता तक्रारी हाताळते. EU मध्ये, तुमच्या राष्ट्रीय डेटा संरक्षण प्राधिकरणाशी संपर्क साधू शकता.',
  },
}
;
